import React, { useEffect,useRef } from 'react'
// import { useTranslation } from 'react-i18next'
import { _Api } from '../../../common/api';
// import Globe from '../../assets/icons/Globe'
// import AppointmentIcon from '../../assets/icons/AppoinmentIcon'
export default function BottomBar({withTitle}) {
    const bottomRef = useRef(null)
    // const [barData ,setBarData] = useState([])

    const BottomBarData = async () => {
        try {
            let postdata = {
                slug:["block-info"]
            }
            let res = await _Api(postdata, `Cms/get-ecom-blocks`)
            if (res?.status === 200) {
               
                // console.log(res,'slug data')
                // setBarData(res?.data)
                
                if (bottomRef.current) {
                  const content = res?.data && Array.isArray(res.data) && res.data[0]?.content
                    ? res.data[0].content
                    : "";
                  bottomRef.current.innerHTML = content;
                }
            }
        }
        catch (err) {
            console.log(err, "err")
        }
    }
      useEffect(()=>{
 BottomBarData();
      },[])
    // const {t} = useTranslation();
   
  return (
    <div className="ecommerce-homepage-bottombar">
        {/* {withTitle ? 
        <div className="ecommerce-homepage-bottombar-title">
        {t("Our Services")}
        </div>
        : null } */}
        <div ref={bottomRef}></div>

</div>
  )
}


